import { render } from "./VsDropdownGroup.vue?vue&type=template&id=27bce4c0"
import script from "./VsDropdownGroup.vue?vue&type=script&lang=js"
export * from "./VsDropdownGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__